/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/viewtype-cards': {
    width: 22,
    height: 23,
    viewBox: '0 0 22 23',
    data: '<rect pid="0" x="3.5" y="4" width="6" height="6" rx=".5" _stroke="#898989"/><rect pid="1" x="3.5" y="13" width="6" height="6" rx=".5" _stroke="#898989"/><rect pid="2" x="12.5" y="4" width="6" height="6" rx=".5" _stroke="#898989"/><rect pid="3" x="12.5" y="13" width="6" height="6" rx=".5" _stroke="#898989"/>'
  }
})
